class ReduxSubscriber {
  constructor() {
    this.listeners = {};
  }

  subscribe(action, listener) {
    const namespace = this.listeners[action];
    if (namespace) {
      this.listeners[action].push(listener);
    } else {
      this.listeners[action] = [listener];
    }
  }

  trigger(action, payload) {
    const namespace = this.listeners[action];

    if (namespace) {
      namespace.forEach((listener) => listener(payload));
    }
  }
}

export default ReduxSubscriber;
